// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attach-message[data-v-d2e21bde] {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  position: relative;
  background: var(--bg-color);
  padding: 5px 0px;
  border-bottom: 1px solid var(--border-info-left);
  min-height: 59px;
  z-index: 1;
  cursor: pointer;
}
.attach-message .color-line[data-v-d2e21bde] {
  height: auto;
  flex-basis: 3px;
  flex-shrink: 0;
  border-radius: 3px;
  background: gray;
  margin-right: 10px;
  margin-left: 14px;
}
.attach-message .attach-block[data-v-d2e21bde] {
  display: flex;
  width: calc(100% - 90px);
}
.attach-message .attach-block .icon-block[data-v-d2e21bde] {
  margin-right: 10px;
}
.attach-message .attach-block .attach-img[data-v-d2e21bde] {
  margin-right: 10px;
}
.attach-message .attach-block .attach-img img[data-v-d2e21bde] {
  height: 50px;
  border-radius: 5px;
}
.attach-message .attach-block .attach-info[data-v-d2e21bde] {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.attach-message .attach-block .attach-info .attach-info-name[data-v-d2e21bde] {
  display: flex;
  flex: 1;
  align-items: center;
  font-size: 16px;
}
.attach-message .attach-block .attach-info .message-text[data-v-d2e21bde] {
  display: flex;
  flex: 1;
  align-items: center;
}
.attach-message .attach-block .attach-info .message-text span[data-v-d2e21bde] {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.attach-message .attach-message-close[data-v-d2e21bde] {
  position: absolute;
  right: 25px;
  top: 19px;
  cursor: pointer;
  height: 20px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.attach-message .attach-message-close .fa-times[data-v-d2e21bde] {
  font-weight: 200;
  color: var(--toolbtn-color);
  font-size: 16px;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/AttachMessage.vue"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,gDAAgD;EAChD,gBAAgB;EAChB,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,OAAO;EACP,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB","sourcesContent":[".attach-message[data-v-d2e21bde] {\n  width: 100%;\n  display: flex;\n  justify-content: flex-start;\n  position: relative;\n  background: var(--bg-color);\n  padding: 5px 0px;\n  border-bottom: 1px solid var(--border-info-left);\n  min-height: 59px;\n  z-index: 1;\n  cursor: pointer;\n}\n.attach-message .color-line[data-v-d2e21bde] {\n  height: auto;\n  flex-basis: 3px;\n  flex-shrink: 0;\n  border-radius: 3px;\n  background: gray;\n  margin-right: 10px;\n  margin-left: 14px;\n}\n.attach-message .attach-block[data-v-d2e21bde] {\n  display: flex;\n  width: calc(100% - 90px);\n}\n.attach-message .attach-block .icon-block[data-v-d2e21bde] {\n  margin-right: 10px;\n}\n.attach-message .attach-block .attach-img[data-v-d2e21bde] {\n  margin-right: 10px;\n}\n.attach-message .attach-block .attach-img img[data-v-d2e21bde] {\n  height: 50px;\n  border-radius: 5px;\n}\n.attach-message .attach-block .attach-info[data-v-d2e21bde] {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n.attach-message .attach-block .attach-info .attach-info-name[data-v-d2e21bde] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n  font-size: 16px;\n}\n.attach-message .attach-block .attach-info .message-text[data-v-d2e21bde] {\n  display: flex;\n  flex: 1;\n  align-items: center;\n}\n.attach-message .attach-block .attach-info .message-text span[data-v-d2e21bde] {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.attach-message .attach-message-close[data-v-d2e21bde] {\n  position: absolute;\n  right: 25px;\n  top: 19px;\n  cursor: pointer;\n  height: 20px;\n  width: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.attach-message .attach-message-close .fa-times[data-v-d2e21bde] {\n  font-weight: 200;\n  color: var(--toolbtn-color);\n  font-size: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
